export default {
  applyToVersions: "<2.6.0",
  type: "before",
  name: "move from updateOnChange boolean to updateType string",
  migrate(data) {
    if (!data.relations) {
      return data;
    }

    for (const relationId in data.relations.items) {
      const relation = data.relations.items[relationId];
      if ("updateType" in relation) break;

      if (relation.none) {
        relation.updateType = "none";
        delete relation.none;
      } else {
        if ("updateOnChange" in relation) {
          if (relation.updateOnChange) {
            relation.updateType = "change";
          } else {
            relation.updateType = "constant";
          }
        } else {
          relation.updateType = "change";
        }
      }
      delete relation.updateOnChange;
    }

    return data;
  }
};
